import { Component, OnInit, forwardRef} from '@angular/core';
import {Message} from 'primeng/primeng';

//constants
import { Constants }         from '../../constants/Constants';


@Component({
  selector: 'my-block',
  templateUrl: './Block.component.html'
//   providers: [{provide: BaseComponent, useExisting: forwardRef(() => BlockComponent)}]
})
export class BlockComponent implements OnInit {

    blocked: boolean;
    blockText: string;
    ngOnInit(): void {
    }
    
}